import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-com-erros',
  templateUrl: './com-erros.component.html',
  styleUrl: './com-erros.component.css'
})
export class ContratosComErrosComponent {

}
